import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const Playhead = ({step=0, isSequenceRolling, sequencerEngine}) => { 

    let rollingStepNumber = undefined;
    let rollSteps = undefined;
    let rollStart = undefined;
    let inner = '';
    if (isSequenceRolling) {
        let track = sequencerEngine.tracks[0];
        if (track) {
            let resolution = track.getFactoredResolution();
            let steps = resolution.getNumberOfStepsAtBaseResolution();
            let _stepNumber = track.patternRollStepNumber + step % steps;
            rollingStepNumber = _stepNumber % track.pattern.stepBuckets.length;
            rollSteps = steps;
            rollStart = track.patternRollStepNumber;
        }
        rollSteps = rollSteps;
        let stepNumber = (rollStart);
        let style = {
            left: ((12*8) * ((4 * Math.floor(stepNumber / 4)) % 32) / 32.0) + 'vw',
            width: ((12*8) * ((4 * Math.floor(rollSteps / 4)) % 32) / 32.0) + 'vw',
        };
        inner = (
            <div className="playhead roll-visualizer" style={style}>
            </div>);

    }

    let style = {
        left: ((12.5*8) * ((4 * Math.floor(step / 4)) % 32) / 32.0) + 'vw'
    };

    return [
        inner,
        <div
          style={style}
          className="playhead"
        ></div>
    ];
}

const mapStateToProps = (state, props) => {
  return {
      step:props.sequencerEngine.trackStep,
      isSequenceRolling: props.sequencerEngine.isSequenceRolling
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Playhead);
